import { createFileRoute } from '@tanstack/react-router';

import { ClaireFailureGroupsPage } from '@/features/admin-terminal/components/claire-failure-groups';

/** Confirmed bad Claire replies, grouped by cause (ENG-2086). */
export const Route = createFileRoute('/_admin/admin/claire-failure-groups')({
  component: ClaireFailureGroupsPage,
});
